export default "/images/d913e838fabe3c09c23353852a645376.avif";